module.exports = __webpack_public_path__ + "img/mobile-rental-plan.95f59a22.svg";